import { Input, InputRef } from 'antd';
import { InputProps, TextAreaProps } from 'antd/es/input';
import TextArea, { TextAreaRef } from 'antd/es/input/TextArea';
import React from 'react';

export const FocusInput: React.FC<InputProps> = props => {
  const ref = React.createRef<InputRef>();
  const [focused, setFocused] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!focused) {
      ref.current!.focus();
      setFocused(true);
    }
  }, [ref, focused, setFocused]);

  return <Input ref={ref} {...props} />;
};

export const FocusTextArea: React.FC<TextAreaProps> = props => {
  const ref = React.createRef<TextAreaRef>();
  const [focused, setFocused] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!focused) {
      ref.current!.focus();
      setFocused(true);
    }
  }, [ref, focused, setFocused]);

  return <TextArea ref={ref} {...props} />;
};
